import styled from 'styled-components';

export const Nav = styled.nav`
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : 'DINRegular ')};
  line-height: 20px;
  display: flex;
  font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '12px')};
  text-transform: uppercase;
  height: 100%;
  transition: all 0.3s;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;

  &.navbg {
    .secondary {
      @media (max-width: 1099px) {
        height: 100% !important;
        position: fixed !important;
        background: #262626 !important;
        display: block;
        transition: 0.5s;
        top: 0px !important;
      }
    }
  }
`;

export const Primary = styled.ul`
z-index: 100;

  &.primary {
    display: flex;
    height: 100%;
    padding: 0;
    list-style-type: none;
    align-items: center;

    @media (min-width: 1400px) {
      margin: ${({ dir }) => (dir === 'rtl' ? '0 250px 0 auto' : '0 auto 0 250px')};
    }

    @media (max-width: 1399px) {
      margin: ${({ dir }) => (dir === 'rtl' ? '0 200px 0 auto' : '0 auto 0 200px')};
    }

    @media (max-width: 1299px) {
      margin: ${({ dir }) => (dir === 'rtl' ? '0 160px 0 auto' : '0 auto 0 160px')};
    }

    @media (max-width: 1199px) {
      margin: ${({ dir }) => (dir === 'rtl' ? '0 0 0 auto' : '0 auto 0 0')};
    }

    @media (max-width: 1099px) {
      position: absolute;
      top: 0;
      transition: 0.5s;
      height: 50px;
      width: 100%;
      background-color: #333;
    }
  }
`;
export const PrimaryNavDesktop = styled.div`
  @media (min-width: 1100px) {
    display: flex;
  }
  display: none;
`;
export const PrimaryNavMobile = styled.div`
  @media (min-width: 1100px) {
    display: none;
  }
  display: flex;
  li {
    &:last-child {
      a {
        &.about-nav,
        &:hover,
        &[aria-current='page'] {
          color: #000;
          background: #f7f7f7;
        }
      }
    }
  }
`;
